"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AutoCompleteMaterial;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _AutoComplete = require("material-ui/AutoComplete");

var _AutoComplete2 = _interopRequireDefault(_AutoComplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AutoCompleteMaterial(_ref) {
  var data = _ref.data,
      label = _ref.label,
      onOptionSelected = _ref.onOptionSelected;

  var handleUpdateInput = function handleUpdateInput(searchText, dataSource, params) {
    // Your custom logic for handling input updates
  };

  var handleNewRequest = function handleNewRequest(chosenRequest, index, dataSource) {
    // Find the selected option in the dropdownData array
    var selectedOption = data.find(function (option) {
      return option.label === chosenRequest;
    });

    if (onOptionSelected) {
      onOptionSelected({ value: selectedOption ? selectedOption.value : "", label: chosenRequest });
    }
  };

  return _react2.default.createElement(_AutoComplete2.default, {
    floatingLabelFixed: true,
    hintText: "Select an option",
    floatingLabelText: label,
    dataSource: data.map(function (item) {
      return item.label;
    }),
    onUpdateInput: handleUpdateInput,
    onNewRequest: handleNewRequest
  });
}


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/components/AutoSuggestMaterial/index.js
// module id = 2134
// module chunks = 1137